import Checkbox from 'components/inputs/Checkbox'
import InputDate from 'components/inputs/Date'
import Modal from 'components/Modal/Modal'
import React, { useState } from 'react'
import { POST } from 'api/request'
import * as url from 'api/urls'

interface EditUserModalProps {
  body: auth.AuthUser
  onClose: () => void
  onReload: (data: Partial<auth.AuthUser>) => void
}

const EditUserModal: React.FC<EditUserModalProps> = ({ body, onClose, onReload }) => {
  const [name, setName] = useState<string>(body.name)
  const [birth, setBirth] = useState<string>(body.birth || '')
  const [isEmailHidden, setEmailHidden] = useState(body.is_email_hidden || false)
  const [consentAdvertising, setConsentAdvertising] = useState(body.consent_advertising || false)
  const [sending, setSending] = useState<boolean>(false)

  const handleSubmit = async () => {
    setSending(true)
    try {
      const body: Partial<auth.AuthUser> = {
        is_email_hidden: isEmailHidden,
        consent_advertising: consentAdvertising
      }
      if (name) body.name = name
      if (birth) body.birth = birth
      const response = await POST(url.userUpdate, {
        body
      })
      if (response.ok) {
        onClose()
        onReload(body)
      }
      else {
        alert('nie zmieniono - response false')
      }
      setSending(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      overflow={false}
      onClose={onClose}
      title='Edytuj dane'
      icon='settings'
      primaryDisabled={sending}
      primaryButton={sending ? 'Wysyłanie...' : 'Zapisz'}
      primaryButtonAction={handleSubmit}
      secondaryButton='Anuluj'
      secondaryButtonAction={'close'}>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1em' }}>
        <div className="myInput">
          <label>Imię i nazwisko</label>
          <input
            type="text"
            placeholder='Wpisz imię i nazwisko'
            value={name}
            onChange={(e) => {
              setName(e.target.value)
            }}
          />
        </div>

        <InputDate
          value={birth}
          onChange={(date) => {
            setBirth(date)
          }}
          label={'Data urodzenia'}
        />

        <Checkbox
          content='Zgody marketingowe'
          checked={consentAdvertising}
          onChanged={setConsentAdvertising}
        />
        
        <Checkbox
          content='Ukryj adres email'
          checked={isEmailHidden}
          onChanged={setEmailHidden}
        />
      </div>
    </Modal>
  )
}

export default EditUserModal